import { GetterTree } from 'vuex';
import { getPageTimes, getVideoTime } from '@/document-tracking/helpers/tracking.helper';
import { IPageTime } from '@/document-view/types/page-time';
import { RootState } from '@/store/store';
import { IDocumentViewState } from '@/store/stores/document-view.store';
import { IVisitTracking } from '@/document-tracking/types/visit-tracking';
import { IRecipient } from '@/types/Recipient';

export const getterTracking = 'tracking';
export const getterTrackingStats = 'trackingStats';
export const getterRecipientsWithTotalVisitTime = 'recipientsWithTotalVisitTime';

export const getters: GetterTree<IDocumentViewState, RootState> = {
  [getterTracking](state: IDocumentViewState, _, rootState: RootState) {
    return (
      recipientId: string = null
    ): {
      videoTracking?: { videoUrl: string; thumbUrl: string; viewDuration: number };
      pageTimes: IPageTime[];
      totalViewTime: number;
    } => {
      const { document } = rootState['dealroomView'];
      if (!state.tracking || !document?.pages?.length) {
        return null;
      }
      const { clickTrackings = [], videoTrackings, pageTrackings } = state.tracking;
      const pageTimes: IPageTime[] = getPageTimes(
        clickTrackings,
        videoTrackings,
        pageTrackings,
        recipientId,
        document.pages
      );

      const pageTimesTotal = pageTimes
        .map(page => page.page_time)
        .reduce((a: number, b: number) => a + b, 0);

      if (!document.video?.video) {
        return { videoTracking: undefined, pageTimes, totalViewTime: pageTimesTotal };
      }

      const { id: engagementVideoId, videoUrl, thumbUrl } = document.video.video;
      const engagementVideoViewDuration = getVideoTime(
        engagementVideoId,
        videoTrackings,
        recipientId
      );

      return {
        videoTracking: {
          videoUrl,
          thumbUrl,
          viewDuration: engagementVideoViewDuration,
        },
        pageTimes,
        totalViewTime: pageTimesTotal + engagementVideoViewDuration,
      };
    };
  },

  [getterTrackingStats](
    state: IDocumentViewState,
    getters
  ): { documentVisitCount: number; documentVisitTime: number; uniqueViewerCount: number } {
    const { totalViewTime } = getters[getterTracking](state?.selectedRecipientId) || {};
    const visitTrackings = state.tracking?.visitTrackings || [];
    const documentVisitCount = visitTrackings.length;
    const uniqueViewerCount = new Set(
      visitTrackings.map((trackVisit: IVisitTracking) => trackVisit.recipientId)
    ).size;

    return { documentVisitCount, documentVisitTime: totalViewTime, uniqueViewerCount };
  },

  [getterRecipientsWithTotalVisitTime](state: IDocumentViewState, getters): IRecipient[] {
    return state.recipients.map(recipient => ({
      ...recipient,
      recipientVisitTime: getters[getterTracking](recipient.id)?.totalViewTime,
    }));
  },
};
